import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import StoreClosedModal from 'components/StoreClosedModal';

import Header from '../../components/Header';
import getFormattedMobileNumber from '../../helpers/getFormattedMobileNumber';
import '../../assets/css/bootstrap.min.css';
import '../../assets/css/swiper.min.css';
import '../../assets/css/style.css';
import '../../assets/css/icon.css';
import '../../assets/css/icon-new.css';
import '../../assets/css/responsive.css';
import '../../index.css'; // add tailwind
import { init, recordPhoneClick, setState } from './actions';
import { selectStoreConfig } from './selectors';
import NotificationModal from 'components/NotificationModal';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.appContainerRef = React.createRef();
  }

  handleTouch = (e) => {
    const {
      changedTouches: [{ pageX }],
    } = e;
    if (pageX < 10 || pageX > window.innerWidth - 10) e.preventDefault();
  };

  componentDidMount() {
    const { storeConfig, initAction } = this.props;
    initAction(storeConfig);
    this?.appContainerRef?.current?.addEventListener(
      'touchstart',
      this.handleTouch
    );
  }

  componentWillUnmount() {
    this?.appContainerRef?.current?.removeEventListener(
      'touchstart',
      this.handleTouch
    );
  }

  recordPhoneClickHandler = () => {
    const { storeConfig, userDetails, recordPhoneClickHandler } = this.props;
    let obj = {
      date: moment().tz(storeConfig.timeZone).format('YYYY-MM-DD HH:mm'),
    };
    if (
      userDetails &&
      userDetails.firstName &&
      userDetails.lastName &&
      userDetails.mobileNumber
    ) {
      obj.firstName = userDetails.firstName;
      obj.lastName = userDetails.lastName;
      obj.mobileNumber = getFormattedMobileNumber(userDetails.mobileNumber);
    }
    obj.storeId = storeConfig.storeId;
    obj.restaurantId = storeConfig.restaurantId;
    recordPhoneClickHandler(obj);
  };

  render() {
    const { storeConfig } = this.props;

    return (
      <div ref={this.appContainerRef}>
        <StoreClosedModal
          storeId={storeConfig.storeId}
          timeZone={storeConfig.timeZone}
        />
        <NotificationModal />
        <Header
          showHalfItem={this.props.showHalfItem}
          spMenuCategories={this.props.spMenuCategories}
          halfItem={this.props.halfItem}
          slideIndex={this.props.slideIndex}
          navigation={this.props.navigation}
          signOut={this.props.signOut}
          currentOrder={this.props.currentOrder}
          goHome={this.props.goHome}
          addReservationhandler={this.props.addReservationhandler}
          history={this.props.history}
          hOrder={this.props.hOrder}
          about={this.props.about}
          closeAbout={this.props.closeAbout}
          review={this.props.review}
          closeReview={this.props.closeReview}
          closeReservation={this.props.closeReservation}
          reservation={this.props.reservation}
          closeLoyalty={this.props.closeLoyalty}
          loyalty={this.props.loyalty}
          recordPhoneClickHandler={this.recordPhoneClickHandler}
          updateCurrentUser={this.props.updateCurrentUser}
          updateOrderStage={this.props.updateOrderStage}
          openDelivery={this.props.openDelivery}
        />
        {this.props.children}
      </div>
    );
  }
}

Layout.propTypes = {
  signOut: PropTypes.any,
  goHome: PropTypes.any,
  history: PropTypes.any,
  updateCurrentUser: PropTypes.any,
  updateOrderStage: PropTypes.any,
};

function mapStateToProps(state) {
  const {
    homeReducer: {
      currentOrder,
      userDetails,
      ui: { slideIndex },
      specialFilter: {
        isSpecialFilterApplied,
        spMenuItems,
        spMenuSizes,
        spSubModifiers,
        spMenuCategories,
      },
    },
  } = state;

  return {
    userDetails,
    isSpecialFilterApplied,
    spMenuItems,
    spMenuSizes,
    spSubModifiers,
    currentOrder,
    spMenuCategories,
    slideIndex,
    //
    storeConfig: selectStoreConfig(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setState: (payload) => dispatch(setState(payload)),
    initAction: (storeId) => dispatch(init(storeId)),
    recordPhoneClickHandler: (obj) => dispatch(recordPhoneClick(obj)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Layout));
